import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/home/u800726540/domains/noventilabs.com/hbuilds/source/repository/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/u800726540/domains/noventilabs.com/hbuilds/source/repository/src/components/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/u800726540/domains/noventilabs.com/hbuilds/source/repository/src/components/Header.tsx");
